import { getFunctions, httpsCallable } from 'firebase/functions'
import { getApp, getApps, initializeApp } from 'firebase/app'
import { CHECK_TIMEOUT_MS, withTimeout } from './checkTimeout'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyC9lSvdpQKR1XEsDKQ9mc6EfjaVjkZYreU',
  authDomain: 'kidneyrecipes.firebaseapp.com',
  projectId: 'kidneyrecipes',
  storageBucket: 'kidneyrecipes.firebasestorage.app',
  messagingSenderId: '810820724974',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:810820724974:web:4f3cd0fdb33b892f83abff',
}

const app = getApps().length ? getApp() : initializeApp(firebaseConfig)
const functions = getFunctions(app)
const checkFn = httpsCallable<{ email: string }, CheckResult>(functions, 'checkExistingSubscription')

export interface CheckResult {
  alreadySubscribed: boolean
  platform: 'ios' | 'android' | 'web' | 'other' | null
  expiresAt: string | null
  /** Paid on the funnel earlier, no account claimed it yet (server since 2026-10-24). */
  pendingWebPurchase?: boolean
}

const NOT_SUBSCRIBED: CheckResult = { alreadySubscribed: false, platform: null, expiresAt: null }

/**
 * Returns whether the email already has an active KidneyPal Pro subscription.
 * Fails open: any error or timeout (CHECK_TIMEOUT_MS, see checkTimeout.ts) resolves
 * to NOT_SUBSCRIBED so we never block legitimate signups due to a backend hiccup.
 */
export async function checkExistingSubscription(email: string): Promise<CheckResult> {
  const call = checkFn({ email }).then((res) => res.data).catch((err) => {
    console.error('checkExistingSubscription error (failing open):', err)
    return NOT_SUBSCRIBED
  })
  return withTimeout(call, CHECK_TIMEOUT_MS, NOT_SUBSCRIBED)
}

export type ClaimStatus = 'claimed' | 'pending_unverified' | 'none'
const claimFn = httpsCallable<unknown, { status?: ClaimStatus }>(functions, 'claimWebPurchase')

/**
 * Attach a parked web purchase to the signed-in account (functions/src/claimWebPurchase.ts).
 * 'pending_unverified' = an email+password account must click the verification link first.
 * Never throws: a failure reads as 'none' (the profile trigger may still link it).
 */
export async function claimWebPurchase(): Promise<ClaimStatus> {
  try {
    const res = await claimFn({})
    return res.data?.status ?? 'none'
  } catch (err) {
    console.error('claimWebPurchase error:', err)
    return 'none'
  }
}
